import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DescriptorLink} from "../../../shared/property/descriptor-link.model";
import {Property} from "../../../shared/property/property.model";
import {ConfigStructure} from "../../../config/config-structure.model";
import {AppConfigService} from "../../../config/app-config.service";
import {TranslatorService} from "../../../shared/translator.service";
import {AppUtils} from "../../../shared/app-utils";
import {MaterializationService} from "./materialization.service";
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {TabConfigStructure} from "../../../config/tab-config-structure";
import {ObjectDetailTitle} from "../../search-list/results/result-item/object-detail-title.model";
import {ObjectLink} from "../object-title/object-link.model";
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-materialization',
  templateUrl: './materialization.component.html',
  styleUrls: ['./materialization.component.css']
})
export class MaterializationComponent implements OnInit, OnChanges {

  @Input() materializationInSearchList;

  readonly matType = 'materialization';

  matId = '0';

  matLink = '';

  config: ConfigStructure[];

  statItemCount: number = 0;

  statDigitalLibraryCount: number = 0;

  statLibraryCount: number = 0;

  isbnIds;

  metadataOriginal;

  properties: Property[];

  title: Property;

  authors: DescriptorLink[];

  matIds$ = new BehaviorSubject<string[]>([]);

  searchListMode = false;

  titleWrapper = new ObjectDetailTitle({authors: [], title: null, extras: []});

  imgPath: string;

  nlpId;

  constructor(private appConfig: AppConfigService,
              private translator: TranslatorService,
              private materializationService: MaterializationService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: { id: string }) => {
      this.materializationService.getProperties(params.id).subscribe((data) => {
        this.thisConsumeObj(data, params.id);
      });
      if (params.id) {
        this.matId = params.id;
        this.matLink = '/materialization/' + this.matId;
        this.matIds$.next([params.id]);
      }
    });
    this.imgPath = 'apiCoverUrl/api' + this.matLink + '/cover';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.thisConsumeObj(this.materializationInSearchList, this.materializationInSearchList.id);
    this.searchListMode = !!this.materializationInSearchList;
  }

  private thisConsumeObj(data, id: string) {
    this.statLibraryCount = data['stat_library_count'] ? data['stat_library_count'] : 0;
    this.statDigitalLibraryCount = data['stat_digital_library_count'] ? data['stat_digital_library_count'] : 0;
    this.statItemCount = data['stat_item_count'] ? data['stat_item_count'] : 0;
    this.properties = AppUtils.mapObjectToProperties(data);
    this.metadataOriginal = data['metadata_original'];
    this.isbnIds = data['mat_isbn'];
    this.nlpId = data['mat_nlp_id'];
    this.title = this.translator.find(this.properties, 'mat_title_proper');
    let property = this.getAuthors();
    if (property) {
      this.authors = property.value;
    }
    this.matId = id;
    this.matLink = '/materialization/'+ this.matId;
    this.matIds$.next([id]);

    const authorObjectLink = this.getAuthorsAsObjectLink();
    const titleObjectLink = new ObjectLink({label: this.title != null ? this.title.value.toString() : ""});

    const extras = this.getEForm();

    this.titleWrapper = new ObjectDetailTitle({authors: [authorObjectLink],title: titleObjectLink,extras: [extras]});
  }

  private getAuthorsAsObjectLink() {
    let authors = this.getAuthors();
    if (!authors || (authors && !authors.value)){
      return new ObjectLink({label: ""});
    }
    let value = authors.value;
    let label = "";
    if (value instanceof Array) {
      label = value[0];
    } else {
      label = value;
    }
    return new ObjectLink({label: label.toString()});
  }

  getConfig(): TabConfigStructure[] {
    return this.appConfig.materializationConfig.bookConfig;
  }

  getEForm(): string {
    let property = this.translator.find(this.properties, 'eForm');
    if (property) {
      return property.value;
    } else {
      return '';
    }
  }

  private getAuthors(): Property {
    return this.translator.find(this.properties, 'work_creator');
  }
}
